export const ORDERBOOK_RESIZE_DEBOUNCE_MS = 1000 / 240;
